import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import VendorHeader from "./../../component/VendorHeader";
import VendorFooter from "./../../component/VendorFooter";
import { API_BASE_URL, IMAGE_URL } from "../../utils/app_url";
import { useLanguage } from "../../context/LanguageContext";
import { useAuth } from "../../context/AuthContext";
import Sidebar from "../../component/Sidebar";

const AdminBlogListing = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { langJson } = useLanguage();
  const actionDivRef = useRef(null);

  const [blogList, setBlogList] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchBlogs = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}stores/admin/blogs`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${user.authorisation.token}`,
        },
      });
      const responseData = await response.json();
      if (responseData.res === true) {
        const list = responseData.data?.data || responseData.data;
        setBlogList(Array.isArray(list) ? list : []);
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching blogs:", error);
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this blog?")) {
      try {
        const response = await fetch(`${API_BASE_URL}stores/admin/blogs/${id}`, {
          method: "DELETE",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.authorisation.token}`,
          },
        });
        const responseData = await response.json();
        if (responseData.res === true) {
          let tempArray = [...blogList];
          let selIndex = tempArray.findIndex(item => parseInt(item?.id) === parseInt(id));
          tempArray.splice(selIndex, 1);
          setBlogList(tempArray);
        }
      } catch (error) {
        console.error("Error deleting blog:", error);
      }
    }
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  return (
    <div>
      <div className="dashHeader">
        <VendorHeader />
      </div>
      <div className="adminDash">
        <Sidebar />
        <div className="rightSide rightTop">
          <h2>{langJson?.blogs ?? "Blogs"}</h2>
          <div className="prdtTopRight">
            <Link to="/admin/blogs/add">{langJson?.addnewblog ?? "Add New Blog"}</Link>
          </div>
          <div className="prdtTable">
            <table>
              <tr>
                <th>{langJson?.image ?? "Image"}</th>
                <th>{langJson?.title}</th>
                <th>{langJson?.author ?? "Author"}</th>
                <th>{langJson?.publishedat ?? "Publish Date"}</th>
                <th>{langJson?.action}</th>
              </tr>
              {blogList?.map((item, index) => (
                <tr key={index}>
                  <td>
                    {item?.featured_image ? (
                      <img
                        src={IMAGE_URL + item.featured_image}
                        alt=""
                        style={{ width: 60, height: 60, objectFit: "cover", borderRadius: 4 }}
                      />
                    ) : "-"}
                  </td>
                  <td>{item?.title || "-"}</td>
                  <td>{item?.author || "-"}</td>
                  <td>{item?.published_at || "-"}</td>
                  <td className="actionHolder">
                    <div className="actionDiv" ref={actionDivRef}>
                      <button onClick={() => navigate(`/admin/blogs/edit/${item?.id}`)}>{langJson?.edit}</button>
                      <button onClick={() => handleDelete(item?.id)}>{langJson?.delete}</button>
                    </div>
                  </td>
                </tr>
              ))}
            </table>
          </div>
        </div>
      </div>
      <VendorFooter />
    </div>
  );
};

export default AdminBlogListing;
